export default __webpack_public_path__ + "static/media/step_013.8c7c4d4f.jpeg";